import React from 'react';
import classNames from 'classnames';
import { omit } from 'lodash';

import { type WithTranslation } from '@wix/yoshi-flow-editor';
import withTranslate from '../../hoc/with-translate';
import IconButton from '../icon-button';
import { NotificationIcon } from '../icons/notification-icon';

type Props = Omit<React.ComponentProps<typeof IconButton>, 'icon'> & Pick<WithTranslation, 't'>;

const NotificationButton = ({ className, t, ...otherProps }: Props) => (
  <IconButton
    className={classNames('notification-button', className)}
    icon={NotificationIcon}
    label={t('header.notifications')}
    aria-label={t('header.notifications')}
    {...omit(otherProps, 'dispatch')}
  />
);

export default withTranslate(NotificationButton);
